const TokenValidationStatus = {
  PENDING: 'pending',
  SUCCESS: 'success',
  FAILURE: 'failure'
};

export default TokenValidationStatus;

